import { render } from "./ChangeHistoryTrans.vue?vue&type=template&id=66ba3567"
import script from "./ChangeHistoryTrans.vue?vue&type=script&lang=js"
export * from "./ChangeHistoryTrans.vue?vue&type=script&lang=js"

import "./ChangeHistoryTrans.vue?vue&type=style&index=0&id=66ba3567&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__